import { Suspense, useEffect, useState } from "react";
import FirComponent from "./FIR/FirComponent";
import { FIRLoading, FIRType } from "../../../db/model";
import { GetFirDataAPI } from "../../../db/apiCalls";
import { toast } from "react-toastify";
import ErrorBoundary from "../../../ErrorBoundary";

function FabricInwardRegister() {
  const [firData, setFirData] = useState<FIRType[]>(FIRLoading);

  async function getFirData() {
    let result = await GetFirDataAPI();

    const data = result
      ? JSON.parse(result)
      : {
          statusCode: 0,
          message:
            "Something went wrong, Please check your internet connection.",
          success: false,
          fabricInwards: [],
        };

    if (data.success) {
      let firarray: FIRType[] = data.fabricInwards;
      return firarray;
    } else {
      toast.error(
        `Error fetching FIR Data, ${data.statusCode} : ${data.message}`
      );
      return [];
    }
  }

  useEffect(() => {
    getFirData().then((data) => {
      setFirData(data);
    });
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<h3>Loading...</h3>}>
        {/* <div className="text-end w-full sticky top-0">
          <Link
            to="/orders/new-order"
            className="bg-blue-600 text-white justify-center border-0 rounded-lg py-1 px-3"
          >
            <NoteAddIcon fontSize="small" className="mb-1 my-auto" /> Add
          </Link>
        </div> */}
        <FirComponent firData={firData} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default FabricInwardRegister;
